import React from 'react';
import { IPermanentMedicament } from '../PernamentMedicationItem';
import EPrescriptionMedicamentsHVLPForm, {
	EPrescriptionHVLPMedicament,
} from '../../EPrescriptionMedicamentsHVLPForm';
import { useUpdateUserMedicationLastedMutation } from '../../../../../graphql/graphql';
import useNotification from '../../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../../Hooks/useTranslation';
import EPrescriptionMedicamentsIPLPForm from '../../EPrescriptionMedicamentsIPLPForm';

interface Props {
	medicament: IPermanentMedicament;
	formType: string;
	onEdit: () => void;
}

const PermanentMedicationEdit: React.FC<Props> = ({
	medicament,
	formType,
	onEdit,
}) => {
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const [updatePermanentMedication] = useUpdateUserMedicationLastedMutation();
	const isHVLP = formType === 'hvlp';
	const isIPLP = formType === 'iplp';

	const handleSubmit = async (values: any) => {
		const result = await updatePermanentMedication({
			where: { id: medicament.id },
			data: { data: values },
		});
		if ('data' in result) {
			showNotificationSuccess({
				content: t('component.permanentMedicationEdit.successfullyEdited'),
			});
			onEdit();
		}
	};

	if (isHVLP) {
		return (
			<EPrescriptionMedicamentsHVLPForm
				onSubmit={handleSubmit}
				isSelfPayer={false}
				defaultValues={medicament.data}
				submitButtonText='base.shared.save'
			/>
		);
	}

	if (isIPLP) {
		return (
			<EPrescriptionMedicamentsIPLPForm
				onSubmit={handleSubmit}
				isSelfPayer={false}
				defaultValues={medicament.data}
				submitButtonText='base.shared.save'
			/>
		);
	}

	return <></>;
};

export default PermanentMedicationEdit;
